export default "__VITE_ASSET__aec377d0__"